import { CheckCircle2, Circle, Sparkles } from "lucide-react";
import type { ProfileCompletionStep } from "../../../types/candidateProfile.types";

interface ProfileCompletionProps {
  percent: number;
  steps: ProfileCompletionStep[];
}

export default function ProfileCompletion({ percent, steps }: ProfileCompletionProps) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <Sparkles size={18} className="text-blue-600" />
            <h2 className="text-lg font-semibold text-slate-900">Profile Completion</h2>
          </div>
          <p className="mt-1 text-sm text-slate-500">Complete your profile to improve recruiter visibility.</p>
        </div>

        <div className="rounded-full bg-green-100 px-4 py-2 text-sm font-semibold text-green-700">{percent}% Completed</div>
      </div>

      <div className="mt-6">
        <div className="mb-2 flex justify-between text-sm">
          <span className="text-slate-500">Progress</span>
          <span className="font-semibold text-blue-600">{percent}%</span>
        </div>
        <div className="h-2 overflow-hidden rounded-full bg-slate-200">
          <div className="h-full rounded-full bg-gradient-to-r from-blue-600 to-cyan-500" style={{ width: `${percent}%` }} />
        </div>
      </div>

      <div className="mt-6 grid gap-3 md:grid-cols-2 xl:grid-cols-4">
        {steps.map((item) => (
          <div key={item.title} className="flex items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
            {item.completed ? (
              <CheckCircle2 size={18} className="text-green-600" />
            ) : (
              <Circle size={18} className="text-slate-400" />
            )}
            <span className="text-sm font-medium">{item.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
}